"use strict";
/**
 * 日历
 */
angular.module("activityCalendarModule", []).
directive("activityCalendar", ["$timeout", "$filter", "$templateRequest", "$compile", "activityCalendarService", 'modalDialog', function($timeout, $filter, $templateRequest, $compile, activityCalendarService, modalDialog) {
    return {
        restrict: "E",
        replace: false,
        scope: {
            calendarTime: "=",
            cancel: "&",
            clickEventBar: "&"
        },
        link: function(scope, $elem, $attrs) {
            initStatus();
            initData();
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {
                    selectedDays: [],
                };
                scope.data = {
                    eventSources: [
                        []
                    ]
                };
                initInterval();
                initCalendar();
                loadTemplate();
                listenKeyEvent();
            }
            /**
             * [listenKeyEvent description] 监听键盘事件开始
             * @return {[type]} [description]
             */
            function listenKeyEvent() {
                var keydown = function(event) {
                    if (event.originalEvent.keyCode === 16) {
                        scope.status.isShift = true;
                    }
                    if (event.originalEvent.keyCode === 17) {
                        scope.status.isCtrl = true;
                    }
                };
                var keyup = function() {
                    scope.status.isShift = false;
                    scope.status.isCtrl = false;
                };
                var mousedown = function() {
                    bdBind();
                };
                $("body").bind("keydown", keydown);
                $("body").bind("keyup", keyup);
                $("body").bind("mousedown", mousedown);
                scope.$on("$destroy", function() {
                    $("body").unbind("keydown", keydown);
                    $("body").unbind("keyup", keyup);
                    $("body").unbind("mousedown", mousedown);
                    clearInterval(scope.status.myInterval);
                });
                var promise;
                /**
                 * [bdBind description] 触发双向绑定
                 * @return {[type]} [description]
                 */
                function bdBind() {
                    if (promise) {
                        $timeout.cancel(promise);
                        promise = null;
                    }
                    promise = $timeout(function() {
                        $elem.find(".fc-day").each(function() {
                            if (dateIsSelected($(this).data())) {
                                $(this).addClass("selected");
                            } else {
                                $(this).removeClass("selected");
                            }
                        });
                    }, 200);
                    return promise;
                }

                function dateIsSelected(date) {
                    var flag = false;
                    for (var i in scope.status.selectedDays) {
                        var date_ = scope.status.selectedDays[i].date;
                        if (date.date === scope.status.selectedDays[i].date) {
                            flag = true;
                        }
                    }
                    return flag;
                }
            }
            /**
             * [initInterval description] 初始化定时器
             * @return {[type]} [description]
             */
            function initInterval() {
                scope.status.myInterval = setInterval(function() {
                    highLightNumber();
                }, 200);
            }
            /**
             * [highLightNumber description] 高亮显示数字
             * @return {[type]} [description]
             */
            function highLightNumber() {
                $elem.find(".fc-day-number").each(function() {
                    var date = new Date($(this).data().date);
                    var flag = false;
                    for (var i in scope.calendarTime[0]) {
                        var startDate = new Date(scope.calendarTime[0][i].start);
                        var endDate = new Date(scope.calendarTime[0][i].end - (1000 * 3600 * 24));
                        if (date >= startDate && date <= endDate) {
                            flag = true;
                            break;
                        }
                    }
                    if (flag) {
                        $(this).find("span").addClass("selected");
                    } else {
                        $(this).find("span").removeClass("selected");
                    }
                });
            }
            /**
             * [cancelCalendar description] 取消日历模式
             * @return {[type]} [description]
             */
            scope.cancelCalendar = function() {
                // scope.cancel();
                scope.delFiled();
            };
            /**
             * [addFiled description] 添加场次
             */
            scope.addFiled = function() {
            	console.log(scope.status.selectedDays);
                activityCalendarService.addField(angular.copy(scope.status.selectedDays), angular.copy(scope.calendarTime[0])).
                then(function(data) {
                    $timeout(function() {
                    	scope.calendarTime[0].splice(0, scope.calendarTime[0].length);
                    	scope.calendarTime[0] = scope.calendarTime[0].concat(data);
                    });
                });
            };
            /**
             * [canDelete description] 判断删除键是否可用 
             * @return {[type]} [description]
             */
            scope.disEditable = function() {
                if (scope.status.selectedDays.length===0) return true;
                var flag = true;
                var calendarTime = scope.calendarTime[0];
                var selectedDays = scope.status.selectedDays;
                for (var k = 0; k < calendarTime.length; k++) {
                    var realEndDate = $filter("date")(calendarTime[k].end - 1000 * 3600 * 24, "yyyy-MM-dd");
                    if (selectedDays[0].date === calendarTime[k].sdate && selectedDays[selectedDays.length - 1].date === realEndDate) {
                        flag = false;
                        break;
                    }
                }
                return flag;
            };
            /**
             * [delFiled 删除场次]
             * @return {[type]} [description]
             */
            scope.delFiled = function() {
                modalDialog.confirmModal('删除', '是否删除所选日程的所有场次？', function() {
                    var selectedDays = angular.copy(scope.status.selectedDays);
                    var calendarTime = angular.copy(scope.calendarTime[0]);
                    for (var i in selectedDays) {
                        for (var k = 0; k < calendarTime.length; k++) {
                            if (selectedDays[i].date === calendarTime[k].sdate) {
                                calendarTime.splice(k, 1);
                                k--;
                            }
                        }
                    }
                    scope.calendarTime[0].splice(0, scope.calendarTime[0].length);
                    scope.calendarTime[0] = scope.calendarTime[0].concat(calendarTime);
                });
            };
            /**
             * [loadTemplate description] 加载模板
             * @return {[type]} [description]
             */
            function loadTemplate() {
                $templateRequest("./main/submissionManage/personalLibrary/activity/calendar/activityCalendar_tpl.html").then(function(template) {
                    var $template = $compile($(template))(scope);
                    $elem.append($template);
                });
            }
            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {}
            /**
             * [initCalendar description]初始化日期里配置项，日历相关操作开始
             * @return {[type]} [description]null
             */
            function initCalendar() {
                scope.uiConfig = {
                    calendar: {
                        height: 570,
                        editable: false,
                        header: {
                            left: 'prev',
                            center: 'title',
                            right: 'next'
                        },
                        eventLimit: true, //是否限制每个时间块显示的事件总数
                        views: {
                            month: {
                                eventLimit: 5,
                                eventLimitText: "",
                                displayEventTime: true,
                            }
                        },
                        /**
                         * [eventLimitClick description]点击标识还有几项
                         * @param  {[obj]} cellInfo [description]包括点击的当前时间与隐藏的事件
                         * @return {[type]}          [description]null
                         */
                        eventLimitClick: function(cellInfo) {
                            var selectedDays = [
                                { date: cellInfo.dayEl.data().date },
                                { date: cellInfo.dayEl.data().date }
                            ];
                            activityCalendarService.addField(selectedDays, angular.copy(scope.calendarTime[0])).
                            then(function(data) {
                                $timeout(function() {
                                    scope.calendarTime[0].splice(0, scope.calendarTime[0].length);
                                    scope.calendarTime[0] = scope.calendarTime[0].concat(data);
                                });
                            });
                            //scope.uiConfig.calendar.views.month.eventLimit = 20;
                            /*var selectedEvent = {
                                time: $filter('date')(cellInfo.date._d, "yyyy-MM-dd").toString(),
                                data: cellInfo.segs[0].event,
                                isList: true,
                            };
                            modifyCalandar(selectedEvent);*/
                        },
                        /**
                         * [eventClick description]点击生成的事件条
                         * @param  {[obj]} event   [description]获得当前点击事件块的属性信息，包括开始时间，结束时间和事件的标题与内容
                         * @return {[type]}         [description]null
                         */
                        eventClick: function(event) {
                            var selectedDays = [
                                { date: $filter("date")(new Date(event.start), "yyyy-MM-dd") },
                                { date: $filter("date")(new Date(event.end - (1000 * 3600 * 24)), "yyyy-MM-dd") }
                            ];
                            activityCalendarService.addField(selectedDays, angular.copy(scope.calendarTime[0])).
                            then(function(data) {
                                $timeout(function() {
                                    scope.calendarTime[0].splice(0, scope.calendarTime[0].length);
                                    scope.calendarTime[0] = scope.calendarTime[0].concat(data);
                                });
                            });
                        },
                        /**
                         * [dayClick description]点击日历中的每天
                         * @param  {[obj]} jsEvent     [description]获得当前点击天的具体信息，包括当前时间
                         * @return {[type]}             [description]null
                         */
                        dayClick: function(jsEvent) {
                            if (scope.status.isShift) {
                                //console.log($filter("date")(new Date(), "yyyy-MM-dd").toString());
                                if (scope.status.selectedDays.length === 0) {
                                    scope.status.selectedDays.push({ date: $filter("date")(new Date(), "yyyy-MM-dd").toString() });
                                } else {
                                    var myDate = new Date(Date.parse($(this).data().date));
                                    var seleDate = new Date(Date.parse(scope.status.selectedDays[0].date));
                                    var different = Math.abs(myDate - seleDate) / 1000 / 60 / 60 / 24;
                                    var startDate = myDate > seleDate ? seleDate : myDate;
                                    scope.status.selectedDays = [];
                                    for (var i = 0; i <= different; i++) {
                                        var theDate = (startDate - 0) + i * (1000 * 3600 * 24);
                                        var newDate = new Date(theDate);
                                        scope.status.selectedDays.push({ date: $filter("date")(newDate, "yyyy-MM-dd") });
                                    }
                                }
                            } else if(scope.status.isCtrl){
                            	scope.status.selectedDays.push($(this).data());
                            } else {
                                scope.status.selectedDays = [$(this).data()];
                            }
                            var selectedDays = angular.copy(scope.status.selectedDays);
                            var calendarTime = angular.copy(scope.calendarTime[0]);
                            for (var i in selectedDays) {
                                for (var k in calendarTime) {
                                    if (selectedDays[i].date === calendarTime[k].sdate) {
                                        break;
                                    }
                                }
                            }
                            /*$scope.status.curTime = $filter('date')(jsEvent._d, "yyyy-MM-dd");
                            if ($scope.status.curTime.substr(8, 2) != $scope.status.today) {
                                angular.element('.Almanac').find('.fc-today').removeClass('selectedDay');
                            }
                            angular.element('.Almanac').find('.fc-day').removeClass('selectedDay');
                            angular.element(this).addClass('selectedDay');
                            refresh();*/
                        }
                    }
                };
            }
        }
    };
}]);